<template>
  <div>
    <Button
      type="primary"
      @click="companyModal = true"
      v-hasPermission="[
        'permissionsConfigurationManagement:companyManagement:add_company'
      ]"
      >{{ $t("companyManagement.addCompany") }}</Button
    >
    <Modal
      v-model="companyModal"
      :title="$t('companyManagement.addCompany')"
      :loading="loading"
      @on-ok="companySubmit('companyForm')"
      @on-cancel="companyReset('companyForm')"
      :mask-closable="false"
      :okText="$t('alarms.common.add')"
      :cancelText="$t('alarms.common.cancel')"
    >
      <Form
        ref="companyForm"
        :model="companyForm"
        :label-width="140"
        :rules="ruleValidate"
      >
        <!-- 公司名称 -->
        <FormItem
          :label="$t('companyManagement.companyName')"
          prop="companyName"
        >
          <Input v-model="companyForm.companyName" style="width:300px;"></Input>
        </FormItem>
        <!-- 公司地址 -->
        <FormItem
          :label="$t('companyManagement.companyAddress')"
          prop="companyAddress"
        >
          <Input
            v-model="companyForm.companyAddress"
            style="width:300px;"
          ></Input>
        </FormItem>
        <!-- 母公司名称 -->
        <FormItem
          :label="$t('companyManagement.parentCompanyName')"
          prop="parentCompany"
        >
          <Input
            v-model="companyForm.parentCompany"
            style="width:300px;"
          ></Input>
        </FormItem>
        <!-- 账单邮寄地址 -->
        <FormItem
          :label="$t('companyManagement.billingAddress')"
          prop="companyBillAddress"
        >
          <Input
            v-model="companyForm.companyBillAddress"
            style="width:300px;"
          ></Input>
        </FormItem>
        <!-- 客户类型 -->
        <FormItem
          :label="$t('companyManagement.customerType')"
          prop="customerType"
        >
          <Select
            v-model="companyForm.customerType"
            style="width:300px;"
            placeholder=" "
          >
            <Option
              :value="item.id"
              v-for="item in customerTypeList"
              v-bind:key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 激活码 -->
        <FormItem :label="$t('message.ActivationCode')">
          <Input
            v-model="companyForm.activeCode"
            style="width:205px"
            disabled
          ></Input>
          <Button type="primary" @click="handleGetactiveCode">{{
            $t("message.getActivationCode")
          }}</Button>
        </FormItem>
        <!-- 激活时长 -->
        <FormItem :label="$t('message.ActivationType')">
          <DatePicker
            type="datetime"
            :options="options"
            v-model="companyForm.vipEndTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :placeholder="$t('companyManagement.pleaseSelectDate')"
            style="width:300px;"
          ></DatePicker>
        </FormItem>
        <!-- 邮件通知回复案例 -->
        <FormItem
          :label="$t('companyManagement.emailNotificationReply')"
          prop="replySwitch"
        >
          <RadioGroup v-model="companyForm.replySwitch">
            <Radio
              v-for="list in replySwitchList"
              :label="list.label"
              :key="list.name"
              >{{ list.name }}</Radio
            >
          </RadioGroup>
        </FormItem>
        <!-- 监控AWS健康仪表盘 -->
        <FormItem
          :label="$t('companyManagement.AWSHealthMonitorDashboard')"
          prop="monitorAwsHealthDashboard"
        >
          <RadioGroup v-model="companyForm.monitorAwsHealthDashboard">
            <Radio
              v-for="list in monitorAwsHealthDashboardList"
              :label="list.label"
              :key="list.name"
              >{{ list.name }}</Radio
            >
          </RadioGroup>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
import TableCompanyManagement from "../company_management/TableCompanyManagement";
var tableCompanyManagement = TableCompanyManagement;
export default {
  data() {
    return {
      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      loading: true,
      companyModal: false,
      customerTypeList: [],
      replySwitchList: [
        {
          id: 0,
          label: "true",
          name: this.$t("companyManagement.yes")
        },
        {
          id: 1,
          label: "false",
          name: this.$t("companyManagement.no")
        }
      ],
      monitorAwsHealthDashboardList: [
        {
          id: 0,
          label: "true",
          name: this.$t("companyManagement.yes")
        },
        {
          id: 1,
          label: "false",
          name: this.$t("companyManagement.no")
        }
      ],
      companyForm: {
        companyName: "",
        companyAddress: "",
        parentCompany: "",
        companyBillAddress: "",
        replySwitch: "true",
        monitorAwsHealthDashboard: "true",
        customerType: "",
        activeCode: "",
        vipEndTime: ""
      },
      ruleValidate: {
        companyName: [
          { required: true, message: this.$t("companyManagement.pleaseInputCompanyName"), trigger: "blur" },
          {
            type: "string",
            message: this.$t("companyManagement.companyNameLength"),
            pattern: "^.{1,100}$",
            trigger: "blur"
          }
        ],
        companyAddress: [
          { required: true, message: this.$t("companyManagement.pleaseInputCompanyAddress"), trigger: "blur" },
          {
            type: "string",
            message: this.$t("companyManagement.companyAddressLength"),
            pattern: "^.{1,100}$",
            trigger: "blur"
          }
        ],
        parentCompany: [
          { required: true, message: this.$t("companyManagement.pleaseInputParentCompanyAddress"), trigger: "blur" },
          {
            type: "string",
            message: this.$t("companyManagement.parentCompanyAddressLength"),
            pattern: "^.{1,100}$",
            trigger: "blur"
          }
        ],
        companyBillAddress: [
          { required: true, message: this.$t("companyManagement.pleaseInputBillingAddress"), trigger: "blur" },
          {
            type: "string",
            message: this.$t("companyManagement.billingAddressLength"),
            pattern: "^.{1,100}$",
            trigger: "blur"
          }
        ],
        replySwitch: [
          {
            required: true,
            message: this.$t("companyManagement.pleaseSelectReplySwitch"),
            trigger: "change",
            type: "string"
          }
        ],
        monitorAwsHealthDashboard: [
          {
            required: true,
            message: this.$t("companyManagement.pleaseSelectMonitorAwsHealthDashboard"),
            trigger: "change",
            type: "string"
          }
        ],
        customerType: [
          {
            required: true,
            message: this.$t("companyManagement.pleaseSelectCustomerType"),
            trigger: "change",
            type: "number"
          }
        ]
      }
    };
  },
  mounted() {
    this.getCustomerTypeDropDownBox();
  },
  methods: {
    // 获取激活码
    handleGetactiveCode() {
      // 请求接口，把拿到的数据放在激活码输入框里面，需要注意，编辑时，如果返回了激活码字段，那么点击按钮不显示
      this.$api.company.generateVipActiveCode().then(res => {
        this.companyForm.activeCode = res.data;
      });
    },
    // 获取客户类型下拉框
    getCustomerTypeDropDownBox: function() {
      this.customerTypeList = [];
      this.$api.company
        .getCustomerTypeDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.customerTypeList = res.data;
        });
    },
    companySubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 添加
          this.$api.company
            .createCompany({
              companyName: this.companyForm.companyName,
              companyAddress: this.companyForm.companyAddress,
              companyBillAddress: this.companyForm.companyBillAddress,
              parentCompany: this.companyForm.parentCompany,
              replySwitch: this.companyForm.replySwitch,
              awsServiceStateMonitor: this.companyForm
                .monitorAwsHealthDashboard,
              customerType: this.companyForm.customerType,
              // 传递接口时需要更改字段
              activeCode: this.companyForm.activeCode,
              vipEndTime: this.companyForm.vipEndTime,
              activeCodeType: 0,
              activeType: 1,
              activeSource: 1,
              activeChannel: "00002"
            })
            .then(res => {
              setTimeout(() => {
                tableCompanyManagement.methods.showAll();
                this.$refs[name].resetFields();
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.$Message.success(this.$t("common.addSuccess"));
                this.companyModal = false;
                this.companyForm.activeCode = "";
                this.companyForm.vipEndTime = "";
              }, 1000);
            });
        } else {
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error(this.$t("common.addFail"));
        }
      });
    },
    companyReset: function(name) {
      this.$refs[name].resetFields();
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/company_management/AddCompanyManagement.vue